import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { ChatTextMessage } from '~/components/ai/AgentDraftingPane/messages/ChatTextMessage';
import { useAnalystEntityResolver } from '../hooks/useAnalystEntityResolver';
import { resolveSummaryText } from '../resolution/resolveSummaryText';
export const AnalystSummaryMessage = (param)=>{
    let { messageId, text } = param;
    const { resolveByValue } = useAnalystEntityResolver();
    const resolvedText = useMemo(()=>resolveSummaryText(text, resolveByValue), [
        text,
        resolveByValue
    ]);
    return /*#__PURE__*/ _jsx(ChatTextMessage, {
        messageId: messageId,
        content: {
            type: 'chat-text',
            text: resolvedText
        }
    });
};
